module.exports = __webpack_public_path__ + "img/1L2.53071e57.png";